



















import {
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: "HeadlessFlipCard",
  components: {

  },
  props: {
    name: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    venue: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    image: {
      type: Object,
      default: {},
    },
    title: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    }
  },
  setup() {
    return {
      flipped: false,
    }
  }
});
